<template>
  <template v-if="getApplicationTemplates && getApplicationTemplates.length">
    <ExperianVerifyWarning />
  </template>
  <div
    class="md:hidden mt-5 w-11/12 mx-auto rounded-lg border-2 border-brand-background-light-blue bg-white"
  >
    <div class="flex items-center px-1 py-2">
      <div class="flex items-center mx-2">
        <img src="@/assets/images/listing-flyer.png" style="min-height: 100px" />
      </div>
      <div class="flex flex-col px-2">
        <h5>Generate branded promotional <br />materials for your listings</h5>
        <router-link class="text-brand-green py-1" :to="{ name: 'dashboard_forms_flyer' }">
          Improve your listings
        </router-link>
      </div>
    </div>
  </div>
  <div class="rounded-lg bg-white px-5 py-5 shadow-sm hidden md:block">
    <div class="flex items-center justify-between">
      <div class="flex flex-col">
        <h5 class="text-brand-black text-2xl pb-5">Application Forms</h5>

        <div class="w-36 pb-3" v-if="getApplicationTemplates && getApplicationTemplates.length">
          <router-link :to="{ name: 'dashboard_new_form' }">
            <SecondaryButton v-if="getCurrentUser.landlord && getCurrentUser.landlord.can_create">
              <div class="flex flex-row">
                <div class="flex items-center mr-1">
                  <PlusIcon class="text-brand-green w-4 h-4" />
                </div>
                <div class="flex items-center">
                  <p class="text-base font-normal">New Form</p>
                </div>
              </div>
            </SecondaryButton>
          </router-link>
        </div>
      </div>

      <div class="flex items-center h-full">
        <div
          class="w-2 h-full my-5 border-l-2 border-brand-background-light-blue"
          style="min-height: 100px"
        ></div>
        <div class="flex items-center mx-2">
          <img src="@/assets/images/listing-flyer.png" style="min-height: 100px" />
        </div>
        <div class="flex flex-col px-2">
          <h5>Generate branded promotional <br />materials for your listings</h5>
          <router-link class="text-brand-green py-1" :to="{ name: 'dashboard_forms_flyer' }">
            Improve your listings
          </router-link>
        </div>
      </div>
    </div>

    <div class="border-b-2 w-full mt-2" style="border-color: #d7def2"></div>

    <!-- START DESKTOP ROW HEADER-->
    <div class="flex flex-row w-full pt-7 pb-3">
      <div class="w-1/3">
        <div class="flex flex-col justify-center h-full w-full pr-2">
          <div class="flex flex-row">
            <div class="flex items-center">
              <h5 class="text-lg font-normal">Form Name</h5>
            </div>
            <div class="flex items-center">
              <SelectorIcon
                class="text-brand-green w-5 h-5 cursor-pointer"
                @click="sortBy('slug')"
              />
            </div>
          </div>
          <p class="italic text-sm">Form URL</p>
        </div>
      </div>

      <div class="w-1/6">
        <div class="flex flex-row">
          <div class="flex items-center">
            <h5 class="text-lg">Fee</h5>
          </div>
          <div class="flex items-center">
            <SelectorIcon
              class="text-brand-green w-5 h-5 cursor-pointer"
              @click="sortBy('price')"
            />
          </div>
        </div>
        <p class="italic text-sm">Paid by applicant</p>
      </div>

      <div class="w-1/4 px-1">
        <h5 class="text-lg px-1">Reports Included</h5>
      </div>

      <div class="w-1/10 px-1">
        <h5 class="text-lg">Settings</h5>
      </div>
      <div class="w-1/10 px-1">
        <h5 class="text-lg">Preview</h5>
      </div>
      <div class="w-1/10 px-1">
        <h5 class="text-lg pl-2">Edit</h5>
      </div>

      <div class="w-1/10 px-1">
        <h5 class="text-lg">Share</h5>
      </div>
    </div>
    <!-- END DESKTOP ROW HEADER-->
  </div>

  <template v-if="isApplicationTemplateLoading">
    <Loading />
  </template>

  <template v-else>
    <template v-if="getApplicationTemplates && getApplicationTemplates.length">
      <!-- START DESKTOP ROW -->
      <div
        class="hidden md:flex flex-row rounded-lg bg-white px-5 py-5 my-5 forms-row"
        v-for="apptemp in getApplicationTemplates"
        :key="apptemp.slug"
      >
        <div class="w-1/3">
          <div class="flex flex-col justify-center h-full w-full">
            <div class="flex flex-row py-1">
              <div
                class="flex items-center overflow-y relative"
                @mouseenter="tooltip[`${apptemp.slug}-link`] = true"
                @mouseleave="tooltip[`${apptemp.slug}-link`] = false"
              >
                <h5 class="text-base font-normal truncate md:max-w-4xs lg:max-w-3xs xl:max-w-2xs">
                  {{ hostname }}/{{ apptemp.slug }}
                </h5>
                <ToolTip
                  :show="tooltip[`${apptemp.slug}-link`]"
                  :label="`${baseHostName}/${apptemp.slug}`"
                />
              </div>

              <div class="flex items-center ml-1">
                <CopyLinkIcon
                  :url="`${origin}/apply/${apptemp.slug}${
                    apptemp.has_agent_field
                      ? `?a=${getEncodedUsername(getCurrentUser.username)}`
                      : ''
                  }`"
                />
              </div>
            </div>
            <p
              class="italic text-sm text-brand-dark-gray truncate md:max-w-4xs lg:max-w-3xs xl:max-w-2xs"
            >
              {{ apptemp.name }}
            </p>
          </div>
        </div>

        <div class="w-1/6">
          <div class="flex items-center h-full">
            <h5 class="text-base font-normal italic">$ {{ apptemp.price }}</h5>
          </div>
        </div>

        <div class="w-1/4 flex flex-col px-1">
          <div
            class="flex flex-col pt-1 pl-1"
            v-if="apptemp.selected_report_sources.length === 0 && !apptemp.landlord.verified"
          >
            <div class="flex flex-row">
              <div class="flex items-center">
                <ExclamationIcon class="w-5 h-5 pr-1 text-brand-yellow" />
              </div>
              <div class="flex items-center">
                <p class="text-sm italic">No reports requested</p>
              </div>
            </div>
            <div class="flex flex-col py-1">
              <p class="text-brand-dark-gray text-xs italic">Applicants will be shown a warning.</p>
              <p class="text-brand-dark-gray text-xs italic">
                <router-link
                  :to="{ name: 'home_applicant_warning_message' }"
                  class="text-brand-green text-left hover:underline"
                  >Click here</router-link
                >
                to learn why we do this
              </p>
            </div>
          </div>
          <div v-else>
            <div
              class="rounded-lg inline-block py-1 px-2 mx-1 my-1"
              v-for="type in apptemp.available_report_sources"
              :key="`${apptemp.slug}-${type}`"
              :class="[
                apptemp.selected_report_sources.includes(type) ||
                apptemp.selected_report_sources.join(',').includes(type)
                  ? 'bg-brand-background-light-blue'
                  : 'bg-brand-light-gray'
              ]"
            >
              <p
                :class="[
                  'text-xs capitalize',
                  apptemp.selected_report_sources.includes(type) ||
                  apptemp.selected_report_sources.join(',').includes(type)
                    ? 'text-brand-blue'
                    : 'text-brand-dark-gray'
                ]"
              >
                {{ type }}
              </p>
            </div>
          </div>
        </div>

        <div class="w-1/10 px-1">
          <div class="flex items-center h-full w-full pl-1">
            <router-link
              :to="{
                name: 'dashboard_form_settings',
                params: { slug: apptemp.slug }
              }"
              :class="[!apptemp.can_edit ? 'text-brand-gray pointer-events-none' : '']"
            >
              <CogIcon
                class="w-8 h-8"
                :class="[
                  apptemp.can_edit
                    ? 'text-brand-green cursor-pointer'
                    : 'text-brand-gray pointer-events-none'
                ]"
              />
            </router-link>
          </div>
        </div>
        <div class="w-1/10 px-1">
          <div class="flex items-center h-full w-full pl-1">
            <router-link
              :to="{
                name: 'apply_form',
                params: { slug: apptemp.slug },
                query: { preview: true }
              }"
            >
              <EyeIcon class="w-8 h-8 text-brand-green cursor-pointer" />
            </router-link>
          </div>
        </div>
        <div class="w-1/10 px-1">
          <div class="flex items-center h-full w-full pl-1">
            <router-link
              :to="{
                name: 'dashboard_form_edit',
                params: { slug: apptemp.slug }
              }"
              :class="[!apptemp.can_edit ? 'text-brand-gray pointer-events-none' : '']"
            >
              <PencilAltIcon
                class="w-8 h-8"
                :class="[
                  apptemp.can_edit
                    ? 'text-brand-green cursor-pointer'
                    : 'text-brand-gray pointer-events-none'
                ]"
              />
            </router-link>
          </div>
        </div>

        <div class="w-1/10 px-1">
          <div class="flex items-center h-full w-full">
            <!-- <PrimaryButton @click="openShareModal(apptemp)"
              ><p class="text-white">Send</p></PrimaryButton
            > -->
            <SendButton @email="openShareModal(apptemp)" @qr="openQRModal(apptemp)" />
          </div>
        </div>
      </div>
      <!-- END DESKTOP ROW -->

      <!-- START MOBILE ROW -->
      <div class="py-2"></div>
      <div
        class="flex flex-col md:hidden bg-white px-2 py-3 my-2"
        v-for="apptemp in getApplicationTemplates"
        :key="apptemp.slug"
      >
        <div class="py-1 pl-2 w-full flex flex-row justify-between">
          <div class="flex flex-row max-w-4/5 pr-2">
            <div class="flex items-center max-w-full">
              <h5 class="text-base font-normal truncate">{{ hostname }}/{{ apptemp.slug }}</h5>
            </div>
            <div class="flex items-center ml-1">
              <CopyLinkIcon
                :url="`${origin}/apply/${apptemp.slug}${
                  apptemp.has_agent_field ? `?a=${getEncodedUsername(getCurrentUser.username)}` : ''
                }`"
              />
            </div>
          </div>
          <div class="flex items-center justify-end">
            <DotsVerticalIcon
              class="h-8 text-brand-mid-gray cursor-pointer"
              @click="openMobileModal(apptemp)"
            />
          </div>
        </div>

        <div class="py-1 px-2 w-full flex flex-row justify-between">
          <div class="flex items-center">
            <h5 class="text-sm font-normal">Fee to applicant</h5>
          </div>
          <div class="flex items-center">
            <h5 class="text-base font-semibold text-end">$ {{ apptemp.price }}</h5>
          </div>
        </div>

        <div class="py-1 flex flex-col">
          <div v-if="apptemp.selected_report_sources.length > 0">
            <div
              class="rounded-lg inline-block py-1 px-2 mx-1 my-1"
              v-for="type in apptemp.available_report_sources"
              :key="`${apptemp.slug}-${type}`"
              :class="[
                apptemp.selected_report_sources.includes(type) ||
                apptemp.selected_report_sources.join(',').includes(type)
                  ? 'bg-brand-background-light-blue'
                  : 'bg-brand-light-gray'
              ]"
            >
              <p
                :class="[
                  'text-2xs capitalize',
                  apptemp.selected_report_sources.includes(type) ||
                  apptemp.selected_report_sources.join(',').includes(type)
                    ? 'text-brand-blue'
                    : 'text-brand-dark-gray'
                ]"
              >
                {{ type }}
              </p>
            </div>
          </div>
          <div class="flex flex-col pt-1 pl-1" v-if="apptemp.selected_report_sources.length === 0">
            <div class="flex flex-row">
              <div class="flex items-center">
                <ExclamationIcon class="w-5 h-5 pr-1 text-brand-yellow" />
              </div>
              <div class="flex items-center">
                <p class="text-sm italic">No reports requested</p>
              </div>
            </div>
            <div class="flex flex-col py-1">
              <p class="text-brand-dark-gray text-xs italic">
                Applicants will be shown a warning.
                <router-link
                  :to="{ name: 'home_applicant_warning_message' }"
                  class="text-brand-green text-left hover:underline"
                  >Click here</router-link
                >
                to learn why we do this
              </p>
            </div>
          </div>
        </div>

        <div class="py-2">
          <div class="flex items-center h-full w-full">
            <SendButton @email="openShareModal(apptemp)" @qr="openQRModal(apptemp)" />
          </div>
        </div>
      </div>
      <!-- END MOBILE ROW -->

      <div class="flex justify-end" v-if="getApplicationTemplatesTotalCount > 0">
        <Pagination
          :current="getApplicationTemplatesCurrentPage"
          :total="getApplicationTemplatesTotalCount"
          :per-page="25"
          @page-changed="loadApptemplates"
        />
      </div>
    </template>

    <template v-else>
      <div class="flex flex-col px-3 py-3 md:py-10 md:items-center justify-center empty-state">
        <div class="w-1/3 md:w-1/6 mx-auto">
          <Lottie :animationData="formEmptyAnimationData" />
        </div>
        <h2 class="py-1 px-2 pb-5 text-xl md:text-3xl text-center">
          Looks like you don’t have any forms yet.
        </h2>
        <template v-if="getCurrentUser.landlord && getCurrentUser.landlord.can_create">
          <div class="flex items-center justify-center py-3">
            <router-link :to="{ name: 'dashboard_new_form' }">
              <PrimaryButton>
                <div class="flex flex-row items-center justify-center py-1 w-48">
                  <div class="flex items-center mr-2">
                    <PlusIcon class="text-white w-5 h-5" />
                  </div>
                  <div class="flex items-center">
                    <p class="text-white">New Form</p>
                  </div>
                </div>
              </PrimaryButton>
            </router-link>
          </div>
          <p class="py-2 text-center">
            Click the "New Form" button to create your first form and get started receiving
            applications.
          </p>
        </template>
      </div>
    </template>
  </template>

  <MobileAdditionalActionModal
    :showModal="showMobileModal"
    @close="closeMobileModal"
    :apptemp="selectedForm"
    @share="openShareModal"
  />
  <ShareModal :showModal="showShareModal" @close="closeShareModal" :apptemp="selectedForm" />

  <WelcomeModal :showModal="showWelcomeModalInternal" @close="closeWelcomeModal" />
  <QRModal :showModal="showQRModal" @close="closeQRModal" :apptemp="selectedForm" />
</template>
<script>
import {
  PlusIcon,
  CogIcon,
  EyeIcon,
  PencilAltIcon,
  DotsVerticalIcon,
  ExclamationIcon,
  SelectorIcon
} from "@heroicons/vue/outline"

import ShareModal from "./components/ShareModal.vue"
import MobileAdditionalActionModal from "./components/MobileAdditionalActionModal.vue"
import ExperianVerifyWarning from "./components/ExperianVerifyWarning.vue"
import WelcomeModal from "./components/WelcomeModal.vue"
import SendButton from "./components/SendButton.vue"
import QRModal from "./components/QRModal.vue"

import FormsEmpty from "@/assets/animations/forms-empty.json"

import { mapGetters } from "vuex"
import btoa from "btoa"

import { APPLICATION_TEMPLATE_GET_LIST, APPLICATION_TEMPLATE_SORT_LIST } from "@/store/types"

export default {
  components: {
    PlusIcon,
    CogIcon,
    EyeIcon,
    PencilAltIcon,
    DotsVerticalIcon,
    ExclamationIcon,
    SelectorIcon,
    MobileAdditionalActionModal,
    ShareModal,
    ExperianVerifyWarning,
    WelcomeModal,
    SendButton,
    QRModal
  },
  computed: {
    ...mapGetters([
      "getApplicationTemplates",
      "isApplicationTemplateLoading",
      "getApplicationTemplatesCurrentPage",
      "getApplicationTemplatesTotalCount",
      "getCurrentUser"
    ]),
    origin() {
      return location.origin
    },
    hostname() {
      return location.hostname
    }
  },
  async mounted() {
    if (this.showWelcomeModal && localStorage.getItem("just_signed_up")) {
      localStorage.removeItem("just_signed_up")
      this.showWelcomeModalInternal = true
    }
    if (!this.getApplicationTemplates || this.$route.query.reload) {
      await this.loadApptemplates(1)
    }
  },
  data() {
    return {
      nameSortDirection: "",
      priceSortDirection: "",
      showMobileModal: false,
      selectedForm: null,
      showShareModal: false,
      formEmptyAnimationData: FormsEmpty,
      showWelcomeModalInternal: false,
      tooltip: {},
      showQRModal: false
    }
  },
  methods: {
    sortBy(type) {
      if (type === "price") {
        if (this.priceSortDirection === "") {
          this.priceSortDirection = "asc"
        } else if (this.priceSortDirection === "asc") {
          this.priceSortDirection = "desc"
        } else {
          this.priceSortDirection = "asc"
        }
      } else {
        if (this.nameSortDirection === "") {
          this.nameSortDirection = "asc"
        } else if (this.nameSortDirection === "asc") {
          this.nameSortDirection = "desc"
        } else {
          this.nameSortDirection = "asc"
        }
      }

      const direction = type === "price" ? this.priceSortDirection : this.nameSortDirection

      this.$store.commit(APPLICATION_TEMPLATE_SORT_LIST, { type, direction })
    },
    async loadApptemplates(page) {
      await this.$store.dispatch(APPLICATION_TEMPLATE_GET_LIST, { page })
    },
    openWelcomeModal() {
      this.showWelcomeModalInternal = true
    },
    closeWelcomeModal() {
      this.showWelcomeModalInternal = false
    },
    openMobileModal(apptemp) {
      this.showMobileModal = true
      this.selectedForm = apptemp
    },
    closeMobileModal(resetSelected = true) {
      this.showMobileModal = false

      if (resetSelected) this.selectedForm = null
    },
    openShareModal(apptemp) {
      this.showShareModal = true
      if (apptemp) this.selectedForm = apptemp

      if (this.showMobileModal) {
        this.showMobileModal = false
      }
    },
    closeShareModal() {
      this.showShareModal = false
    },
    getEncodedUsername(username) {
      return btoa(username)
    },
    openQRModal(apptemp) {
      this.showQRModal = true

      if (apptemp) this.selectedForm = apptemp
    },
    closeQRModal() {
      this.showQRModal = false
    }
  }
}
</script>
